import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateLocationMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  type: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  address: Types.Scalars['String']['input'];
  nickname?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
  phone?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateLocationMutation = { __typename?: 'mutation_root', update_locations?: { __typename?: 'locations_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'locations', id: number, region_id?: number | null, place_id?: string | null, type: string, name?: string | null, address?: string | null, nickname?: string | null, email?: string | null, phone?: string | null, latitude?: number | null, longitude?: number | null }> } | null };


export const UpdateLocationDocument = gql`
    mutation updateLocation($id: bigint!, $type: String!, $name: String!, $address: String!, $nickname: String, $email: String, $phone: String) {
  update_locations(
    where: {id: {_eq: $id}}
    _set: {type: $type, name: $name, address: $address, nickname: $nickname, email: $email, phone: $phone}
  ) {
    affected_rows
    returning {
      id
      region_id
      place_id
      type
      name
      address
      nickname
      email
      phone
      latitude
      longitude
    }
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      address: // value for 'address'
 *      nickname: // value for 'nickname'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/locations/queries/updateLocation.mutation.gql}
 */
export async function updateLocation(
  variables: UpdateLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateLocationMutation['update_locations']>
export async function updateLocation(
  variables: UpdateLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateLocationMutation>
export async function updateLocation(
  variables: UpdateLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateLocationMutation['update_locations'] | UpdateLocationMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateLocationMutation>(
    UpdateLocationDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_locations
}